import { RootState } from 'store/reducer';

export const verticalsDocsState = (state: RootState): RootState['verticalDocs'] => state.verticalDocs;
